module.exports = __webpack_public_path__ + "img/import.1189da00.svg";